export default __webpack_public_path__ + "static/media/23.10663e0a.jpg";